// This function is used to plot the y axis values of graph.
// For eg: The value from endpoint for website traffic chart
// is [{2023-01-01:"13k"},{2023-02-01:"1m"},{2023-03-01:"500k"},]
// If we didn't convert this to number, chart will take values
// [13 , 1, 500] to plot the y axis which is not ideal. This
// function is used to resolve this issue
export const convertStringToNumber = (value: string): number => {
  const suffixes = {
    k: 1000,
    m: 1000000,
    b: 1000000000,
  };

  const numericValue = parseFloat(value);
  const suffix = value.slice(-1).toLowerCase() as "k" | "m" | "b";

  // eslint-disable-next-line no-prototype-builtins
  if (suffixes.hasOwnProperty(suffix)) {
    return numericValue * suffixes[suffix];
  }

  return numericValue;
};

// This function is used to show the chart labels. It converts big
// numbers to short string format. For eg: 13k for 13000.
export const formatNumberWithSuffix = (number: number): string | undefined => {
  if (number) {
    const suffixes = ["", "k", "m", "b"];
    const suffixIndex = Math.floor(Math.log10(number) / 3);
    const abbreviatedNumber = (number / Math.pow(10, suffixIndex * 3)).toFixed(
      1,
    );

    if (number < 1000) {
      return number.toString();
    }

    return (abbreviatedNumber + suffixes[suffixIndex]).toLocaleString();
  }
};

// This function is used to format the date string coming from the
// endpoint response. We are using this to show the x axis label of
// graph. Eg: Jul 23 for 2023-07-01
export const formatMonthYear = (dateString: string): string => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleString("en-US", {
    month: "short",
    year: "2-digit",
  });
  return formattedDate;
};
